// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Form_wrapper__3rppe","form":"Form_form__3AioP","form-control-cb":"Form_form-control-cb__2SP2Y","form-action":"Form_form-action__2821P"};